import CircularProgress, { type CircularProgressProps } from '@mui/material/CircularProgress';
import React from 'react';

interface LoadingPlaceholderProps extends CircularProgressProps {
  isLoading: boolean;
  children?: React.ReactNode;
  className?: string;
  isError?: boolean;
  componentName?: string; //for e2e tests
}

export const LoadingPlaceholder = ({
  isLoading,
  children,
  className,
  isError = false,
  componentName,
  ...props
}: LoadingPlaceholderProps) => {
  if (!isLoading) {
    return !isError ? <>{children}</> : null;
  }

  return (
    <div
      data-testid="loading-placeholder"
      data-component={componentName ?? 'LoadingPlaceHolder'}
      className={className ?? 'w-full text-center mt-8 pb-8'}
    >
      <CircularProgress {...props} />
    </div>
  );
};
